import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { PaymentPanel } from "@/pages/PublicBooking";

export default function PublicReservationPay() {
  const { token } = useParams();
  const [status, setStatus] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/public/pay/${token}`)
      .then((r) => setStatus(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Link pembayaran tidak valid atau sudah tidak berlaku."))
      .finally(() => setLoading(false));
  }, [token]);

  const payInfo = status && {
    mode: status.payment_mode,
    total: status.total_tagihan,
    dp_required: status.dp_required,
    payment_status: status.payment_status,
    deadline: status.payment_deadline,
  };
  const isExpired = status && (status.expired || status.status === "Dibatalkan Otomatis" || status.payment_status === "Kedaluwarsa");

  return (
    <div className="min-h-screen bg-rose-50/40">
      <header className="border-b border-rose-100/70 bg-white">
        <div className="mx-auto max-w-lg px-4 py-4">
          <h1 className="font-heading text-lg font-bold text-[#DB2777]">GBS Clinic — Pembayaran</h1>
          <p className="text-xs text-slate-500">
            {status?.nama_depan ? `Halo ${status.nama_depan}, selesaikan pembayaran reservasi Anda` : "Selesaikan pembayaran reservasi Anda"}
          </p>
        </div>
      </header>
      <main className="mx-auto max-w-lg px-4 py-6" data-testid="public-reservation-pay">
        {loading && <p className="text-sm text-slate-500" data-testid="pay-loading">Memuat…</p>}
        {err && (
          <div data-testid="pay-error" className="rounded-2xl border border-rose-200 bg-rose-50 p-6 text-center text-sm font-semibold text-rose-600">
            {err}
          </div>
        )}
        {!loading && !err && status && (
          isExpired ? (
            <div data-testid="pay-expired" className="rounded-2xl border border-rose-200 bg-white p-6 text-center">
              <p className="text-sm font-semibold text-rose-600">
                Batas waktu pembayaran telah berakhir. Reservasi ini dibatalkan otomatis dan slot telah dilepas. Silakan membuat reservasi baru untuk memilih jadwal yang masih tersedia.
              </p>
              <a data-testid="new-reservation-btn" href="/booking" className="mt-4 inline-block rounded-xl bg-[#DB2777] px-5 py-2.5 text-sm font-bold text-white hover:bg-[#be1e63]">
                Buat Reservasi Baru
              </a>
            </div>
          ) : payInfo.mode === "none" ? (
            <div data-testid="pay-not-required" className="rounded-2xl border border-emerald-200 bg-emerald-50 p-6 text-center text-sm font-semibold text-emerald-700">
              Reservasi ini tidak memerlukan pembayaran online.
            </div>
          ) : (
            <PaymentPanel resId={token} payToken={token} payInfo={payInfo} waInfo={null} />
          )
        )}
      </main>
    </div>
  );
}
